import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { pluralize } from "@common/helpers/string";

interface ConfirmClassChangeModalProps {
    show: boolean;
    onHide: () => void;
    selectedClasses: string[];
    onConfirm: () => Promise<void>;
    selectedCount: number;
    transactionsWithExistingClassCount: number;
}

export const ConfirmClassChangeModal: React.FC<
    ConfirmClassChangeModalProps
> = ({
    show,
    onHide,
    selectedClasses,
    onConfirm,
    selectedCount,
    transactionsWithExistingClassCount,
}) => {
    const hasExistingClasses = transactionsWithExistingClassCount > 0;

    const title = `Update ${pluralize("Class", selectedClasses.length)} for ${numberFormatter.format(selectedCount)} ${pluralize("transaction", selectedCount)}?`;

    const haveOrHas = transactionsWithExistingClassCount > 1 ? "have" : "has";

    const question = hasExistingClasses
        ? `${numberFormatter.format(transactionsWithExistingClassCount)} ${pluralize("transaction", transactionsWithExistingClassCount)} already ${haveOrHas} Classes assigned. The selected Classes will override the existing Classes. Do you want to continue?`
        : `Are you sure you want to apply the selected ${pluralize("Class", selectedClasses.length)} to ${numberFormatter.format(selectedCount)} ${pluralize("transaction", selectedCount)}?`;

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={onConfirm}
            title={title}
            question={question}
            yes="Update"
            yesBtnVariant="primary"
        />
    );
};
